(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSelfRegistration(
    toastr, $filter, EventServiceEvents, RegexModel, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me'
      },
      templateUrl: 'app/components/authenticationSettings/selfRegistration/selfRegistration.template.html',
      link: function(scope) {

        const domainPattern = new RegexModel().domainRegex_v2();
        const illegalCharRegexCheck = new RegexModel().badEmailString_variables().regex;
        scope.BAD_DOMAIN_STRING = new RegexModel().badEmailString_variables().string;



        function domainModel (domain) {
          this.domain = domain;
          this.domainValid = false;
          this.domainPattern = false;
          this.domainIllegalCharacters = false;

          this.validateDomain = () => {
            this.domainPattern = domainPattern.test(this.domain);
            this.domainIllegalCharacters = illegalCharRegexCheck.test(this.domain);
            if (this.domain && this.domainPattern && !this.domainIllegalCharacters) {
              this.domainValid = true;
            } else {
              this.domainValid = false;
            }
          }
        }


        function BuildInModel (buildIn) {
          this.buildinEnabled = buildIn.buildinEnabled;
          this.selfRegistrationAllowed = buildIn.selfRegistrationAllowed;
          this.hideEmailDomains = buildIn.hideEmailDomains || false;
          this.domainModelList = [];

          this.mapBuildInModelDomainModels = (buildIn) => {
            buildIn.allowedEmailDomains.forEach((domain) => {
              const domainModelInstance = new domainModel(domain);
              domainModelInstance.validateDomain();
              this.domainModelList.push(domainModelInstance)
            })
          }

          this.addDomain = (domain) => {
            this.domainModelList.push(new domainModel(domain))
          }

          this.removeDomain = (domain) => {
            this.domainModelList = this.domainModelList.filter( (obj) => {
              return obj.domain !== domain;
            });

            if (!this.domainModelList.length) {
              this.selfRegistrationAllowed = false;
              this.hideEmailDomains = false;
            }
            scope.validateInput()
          }
        }

        scope.validateInput = function () {
          scope.formIsValid = true;

          if (scope.buildInModel.buildinEnabled && !scope.buildInModel.selfRegistrationAllowed && !scope.buildInModel.domainModelList.length) {
            scope.formIsValid = true;
            scope.addingNewDomain = false;
          }

          if (scope.buildInModel.buildinEnabled && scope.buildInModel.selfRegistrationAllowed && !scope.buildInModel.domainModelList.length) {
            scope.formIsValid = false;
            scope.addingNewDomain = true;
          }

          if (scope.buildInModel.buildinEnabled && scope.buildInModel.selfRegistrationAllowed && scope.buildInModel.domainModelList.length) {

            scope.formIsValid = scope.buildInModel.domainModelList.every( (obj) => {
              obj.validateDomain();
              return obj.domainValid;
            })

          }

          var buildInModelString = JSON.stringify(scope.buildInModel);
          var buildInModelCopyString = JSON.stringify(buildInModelCopy);
          if (buildInModelString === buildInModelCopyString) {
            scope.formIsValid = false;
          }
        }



        scope.appendDomain = function () {
          scope.newDomain.validateDomain()
          if (scope.newDomain.domainValid) {
            scope.buildInModel.addDomain(scope.newDomain.domain);
            scope.newDomainPatternValid = true;
            scope.addingNewDomain = false;
            scope.newDomain = new domainModel('');
            scope.validateInput()
          }
        }

        scope.resetNewDomain = function () {
          scope.newDomain = new domainModel('');
          scope.addingNewDomain = false;
        }

        scope.addNewEmailDomain = function() {
          scope.addingNewDomain = true;
        };


        scope.updateSelfRegistration = function () {
          let authenticationConfiguration = angular.copy(scope.tenant.info._embedded.authenticationConfiguration);
          authenticationConfiguration.buildIn.buildinEnabled = scope.buildInModel.buildinEnabled;
          authenticationConfiguration.buildIn.selfRegistrationAllowed = scope.buildInModel.selfRegistrationAllowed;
          authenticationConfiguration.buildIn.hideEmailDomains = scope.buildInModel.hideEmailDomains;
          authenticationConfiguration.buildIn.allowedEmailDomains = scope.buildInModel.domainModelList.map(obj => obj.domain);

          if (!authenticationConfiguration.buildIn.buildinEnabled) {
            authenticationConfiguration.buildIn.selfRegistrationAllowed = false
          }

          if (!authenticationConfiguration.buildIn.selfRegistrationAllowed) {
            authenticationConfiguration.buildIn.hideEmailDomains = false;
            authenticationConfiguration.buildIn.allowedEmailDomains = []
          }


          scope.tenant.saveAuthConfigChanges(authenticationConfiguration).then(function(response) {

          }).catch(function(error) {
            toastr.warning($filter('translate')('NoChangesMade'));
          });

        }

        var buildInModel = null
        var buildInModelCopy = null;

        function init () {
          scope.addingNewDomain = false;
          scope.newDomain = new domainModel('');
          scope.newDomainPatternValid = false;
          scope.deleting = false;
          scope.formIsValid = false;

          buildInModel = new BuildInModel(angular.copy(scope.tenant.info._embedded.authenticationConfiguration.buildIn));
          buildInModel.mapBuildInModelDomainModels(angular.copy(scope.tenant.info._embedded.authenticationConfiguration.buildIn))
          scope.buildInModel = buildInModel;

          buildInModelCopy = new BuildInModel(angular.copy(scope.tenant.info._embedded.authenticationConfiguration.buildIn));
          buildInModelCopy.mapBuildInModelDomainModels(angular.copy(scope.tenant.info._embedded.authenticationConfiguration.buildIn))
          scope.validateInput()
        }

        init();

        scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.AUTH_CONFIG_UPDATED, function(name, data) {
          toastr.success($filter('translate')('ChangesSaved'));

          scope.tenant = TenantListService.currentTenant
          init();

        });

      }
    };
  }

  pxSelfRegistration.$inject = ['toastr', '$filter', 'EventServiceEvents', 'RegexModel', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxSelfRegistration', pxSelfRegistration);

})();
